<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10" class="head_text">
        <el-col :span="12">
          <div>{{ $l('form_original_information') || '原信息内容' }}</div>
        </el-col>
        <el-col :span="12">
          <div>{{ $l('form_information_after_change') || '变更信息内容' }}</div>
        </el-col>
        <el-col :span="24">
          <el-divider></el-divider>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_paymentTerms') || '默认付款条件'"
          >
            <el-input
              v-model="oldForm.v_paymentTermsOld"
              readonly
              :flag="'flag'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_paymentTerms') || '默认付款条件'"
            prop="paymentTerms"
          >
            <dict-select
              v-model="formData.paymentTerms"
              :selectedLabel.sync="formData.v_paymentTerms"
              url="/master/common/dict/biz"
              :body="{ dictType: 'paymentTerms' }"
              :placeholder="
                $l('form_placeholder_paymentTerms') || '请选择默认付款条件'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="
              $l('form_label_discountSalesAmount') || '货款结算是否包含佣金'
            "
          >
            <el-input
              v-model="oldForm.v_discountSalesAmountOld"
              readonly
              :flag="'flag'"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="
              $l('form_label_discountSalesAmount') || '货款结算是否包含佣金'
            "
            prop="discountSalesAmount"
          >
            <el-select
              v-model="formData.discountSalesAmount"
              :placeholder="
                $l('form_placeholder_discountSalesAmount') ||
                '请选择货款结算是否包含佣金'
              "
              filterable
              clearable
              style="width: 100%"
            >
              <el-option
                value="Y"
                :label="$l('form_label_discountSalesAmount_Y') || '包含佣金'"
              />
              <el-option
                value="N"
                :label="$l('form_label_discountSalesAmount_N') || '不包含佣金'"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10"> </el-row>
    </el-form>

    <div class="pt-3 pb-1">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center">
          <h6 class="m-0">
            {{ $l('form_header_takeOrder') || '接单抬头设置' }}
          </h6>
          <el-divider direction="vertical" />
          <b-button
            size="sm"
            variant="outline-success"
            @click="addTakeOrder"
            :disabled="enableEdit"
          >
            {{ $l('btn_addTakeOrder') || '新增接单设置' }}
          </b-button>
        </div>
        <!-- <div>
          <vxe-button
            size="mini"
            circle
            @click="getTakeOrderData()"
            :disabled="enableEdit"
          >
            <i class="vxe-button--icon vxe-icon--refresh" />
          </vxe-button>
        </div> -->
      </div>

      <div class="cust-takeOrder-list">
        <el-form
          v-for="(form, index) in newTakeOrderList"
          :key="index"
          ref="takeOrderForm"
          :model="form"
          :rules="takeOrderRules"
          size="mini"
          label-position="top"
          :disabled="!form.enableEdit"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_takeOrderOrgCode') || '接单抬头设置'"
                prop="takeOrderOrgCode"
              >
                <dict-select
                  v-model="form.takeOrderOrgCode"
                  :selectedLabel.sync="form.takeOrderOrgName"
                  :placeholder="
                    $l('form_placeholder_takeOrderOrg') || '请选择接单抬头设置'
                  "
                  url="/digitalCenter/common/dict/system"
                  :body="{ dictType: 'takeOrderOrgCode' }"
                  clearable
                  filterable
                  size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_takeOrderOrgName') || '收汇抬头'"
              >
                <el-input v-model="form.takeOrderOrgName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <template #label>
                  <div><br /></div>
                </template>
                <div class="text-right" v-if="!enableEdit && !form.enableEdit">
                  <el-tooltip
                    effect="dark"
                    :content="$l('INDEX.btn_tips_del') || '删除'"
                    placement="top"
                  >
                    <i
                      class="el-icon-delete text-danger tool-btn"
                      @click="delTakeOrder(index)"
                    />
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    :content="$l('INDEX.btn_tips_edit') || '编辑'"
                    placement="top"
                  >
                    <i
                      class="el-icon-edit tool-btn"
                      @click="editTakeOrder(form)"
                    />
                  </el-tooltip>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_takeOrderType') || '订单类型限制'"
                prop="takeOrderType"
              >
                <dict-select
                  v-model="form.takeOrderType"
                  :selectedLabel.sync="form.v_takeOrderType"
                  :placeholder="
                    $l('form_placeholder_takeOrderType') || '请选择订单类型限制'
                  "
                  url="/digitalCenter/common/dict/system"
                  :body="{ dictType: 'takeOrderType' }"
                  clearable
                  filterable
                  size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_executeOrgCode') || '国内业务执行公司'"
                prop="executeOrgCode"
              >
                <dict-select
                  v-model="form.executeOrgCode"
                  :selectedLabel.sync="form.executeOrgName"
                  :placeholder="
                    $l('form_placeholder_executeOrg') ||
                    '请选择国内业务执行公司'
                  "
                  url="/digitalCenter/common/dict/system"
                  :body="{ dictType: 'takeOrderOrgCode' }"
                  clearable
                  filterable
                  size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('form_label_executeOrgName') || '国内公司采购合同甲方抬头'
                "
              >
                <el-input v-model="form.executeOrgName" readonly />
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="form.enableEdit" class="my-2 d-flex justify-content-end">
            <el-button size="small" @click="cancelEditTakeOrder(index)">
              {{ $l('INDEX.btn_cancel') || '取消' }}
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="saveTakeOrder(form, index)"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </el-form>
        <EmptyContent v-if="!newTakeOrderList || !newTakeOrderList.length" />
      </div>
    </div>

    <el-form ref="formChange" :model="formData" :rules="rules" size="mini">
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="mt-3 mb-1">
            <h6>
              <span class="text-danger">*</span>
              <span style="color: #101010">
                {{
                  $l('form_label_reason_change_explanation') || '变更原因说明'
                }}
              </span>
            </h6>
            <p
              style="font-size: 14px; color: #6c6c6c"
              class="m-0 text-truncate"
            >
              {{
                $l('form_ple_fill_in_explanation_for_change') ||
                '请填写本次变更信息的情况说明'
              }}
            </p>
          </div>
          <el-form-item prop="remark">
            <div>
              <el-input
                v-model="formData.remark"
                type="textarea"
                :rows="6"
                :maxlength="500"
                show-word-limit
                clearable
                @change="valueChange"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('dialog_want_to_submit_changes') || '是否要提交变更' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('btn_not_submit_changes') || '不提交变更' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('btn_submit_changes') || '提交变更' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initTakeOrder = { enableEdit: true }
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import EmptyContent from '../empty-content'
import { cloneDeep } from 'lodash'
export default {
  mixins: [EditLoading],
  components: { EmptyContent },
  props: {
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      valueChangeFlag: false,
      formData: {},
      oldForm: {},
      newTakeOrderList: [],
      oldTakeOrderList: [],
      currTakeOrder: {},

      takeOrderRules: {
        takeOrderOrgCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_takeOrderOrg') || '请选择接单抬头设置',
            trigger: 'change',
          },
        ],
        takeOrderType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_takeOrderType') || '请选择订单类型限制',
            trigger: 'change',
          },
        ],
        executeOrgCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_executeOrg') ||
              '请选择国内业务执行公司',
            trigger: 'change',
          },
        ],
      },
      rules: {
        paymentTerms: [
          {
            required: true,
            message:
              this.$l('form_placeholder_paymentTerms') || '请选择默认付款条件',
            trigger: 'change',
          },
        ],

        discountSalesAmount: [
          {
            required: true,
            message:
              this.$l('form_placeholder_discountSalesAmount') ||
              '请选择货款结算是否包含佣金',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('form_placeholder_reason') || '请输入变更原因说明',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    enableEdit() {
      return this.newTakeOrderList.some((item) => !!item.enableEdit)
    },
  },
  mounted() {
    this.getData()
    this.getTakeOrderData()
  },
  methods: {
    valueChange() {
      this.valueChangeFlag = true
    },
    async getData() {
      if (!this.custCode) return
      this.loading = true
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => {})
      this.loading = false
      const data = res.body || {}
      this.formData = { ...data }
      for (const key in this.formData) {
        const newKey = key + 'Old'
        this.oldForm[newKey] = this.formData[key]
      }
    },

    async getTakeOrderData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerTakeOrderListApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body?.data || []
      this.newTakeOrderList = data.map((item) => ({
        ...item,
        enableEdit: false,
      }))
      this.oldTakeOrderList = cloneDeep(this.newTakeOrderList)
    },
    addTakeOrder() {
      this.newTakeOrderList.push({ ...initTakeOrder })
      this.currTakeOrder = null
      this.valueChangeFlag = true
    },
    async editTakeOrder(takeOrder) {
      if (this.enableEdit) return
      this.currTakeOrder = JSON.parse(JSON.stringify(takeOrder))
      takeOrder.enableEdit = true
      this.valueChangeFlag = true
    },
    async saveTakeOrder(takeOrder, index) {
      if (
        !(await validate.formValidate([this.$refs['takeOrderForm'][index]]))
      ) {
        return
      }
      takeOrder.enableEdit = false
      this.valueChangeFlag = true
    },
    cancelEditTakeOrder(index) {
      if (!this.currTakeOrder) {
        this.newTakeOrderList.splice(index, 1)
      } else {
        this.$set(this.newTakeOrderList, index, { ...this.currTakeOrder })
      }
      this.valueChangeFlag = true
    },
    delTakeOrder(index) {
      this.newTakeOrderList.splice(index, 1)
      this.valueChangeFlag = true
    },

    async save() {
      const result = await validate.formValidate([
        this.$refs.form,
        this.$refs.formChange,
      ])
      const takeResult = await validate.formValidate(this.$refs.takeOrderForm)
      if (!result || !takeResult) return (this.backDialogVisible = false)
      if (!this.newTakeOrderList || !this.newTakeOrderList.length) {
        this.$message.warning(
          this.$l('tip_order_header_cannot_empty') || '接单抬头设置不能为空！'
        )
        return (this.backDialogVisible = false)
      }
      const enable = this.newTakeOrderList.find(
        (item) => item.enableEdit === true
      )
      if (enable) {
        this.$message.warning(
          this.$l('tip_order_header_save_resubmit') ||
            '请保存接单抬头设置后重新提交变更！'
        )
        return (this.backDialogVisible = false)
      }

      let param = {}
      for (const key in this.formData) {
        if (key == 'remark') continue
        const newKey = key + 'Old'
        if (this.oldForm[newKey] != this.formData[key]) {
          param[key] = this.formData[key]
        }
      }
      if (
        Object.keys(param).length === 0 &&
        JSON.stringify(this.newTakeOrderList) ===
          JSON.stringify(this.oldTakeOrderList)
      ) {
        this.$message.warning(
          this.$l('tip_information_not_change') ||
            '信息未变更，请修改后重新提交变更！'
        )
        return (this.backDialogVisible = false)
      }
      param.newTakeOrderList = this.newTakeOrderList
      param.oldTakeOrderList = this.oldTakeOrderList
      param.remark = this.formData.remark
      if (param.discountSalesAmount) {
        param.v_discountSalesAmount =
          param.discountSalesAmount == 'Y'
            ? this.$l('form_label_discountSalesAmount_Y') || '包含佣金'
            : this.$l('form_label_discountSalesAmount_N') || '不包含佣金'
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerOrderChangeApi({
          updateContent: JSON.stringify(param),
          custCode: this.formData.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_submission_failed') || '提交失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
      return true
    },

    cancel() {
      if (!this.valueChangeFlag) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.valueChangeFlag = false
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card {
    border: none;
  }
  .el-card__body {
    padding: 16px;
  }
  .el-divider--horizontal {
    margin: 12px 0;
  }

  .el-input .el-input__inner[flag='flag'] {
    background-color: #f9f9f9;
    border: none !important;
  }
}
.head_text {
  color: #101010;
  font-size: 16px;
  font-weight: 600;
}

::v-deep {
  .cust-takeOrder-list,
  .cust-bank-list {
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
